<template>
  <div class="modal fade fill-in disable-scroll" id="modal" tabindex="-1" role="dialog" aria-hidden="false"
    style="z-index: 9999" data-backdrop="static">
    <div class="modal-dialog modal-confirm modal-lebar modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="card shade">
            <div class="card-header d-flex">
              <div class="h4">Pencarian Lanjutan</div>
              <div class="shade ml-auto clickable hoverable bg-white" style="
                  margin-right: -30px;
                  margin-top: -25px;
                  height: 2rem;
                  width: 2rem;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                " data-dismiss="modal" @click="closeModal">
                <i class="bi bi-x" style="font-size: 30px"></i>
              </div>
            </div>
            <div class="card-body mt-3">
              <form @submit.prevent="startSearch()">
                <!-- field kata dicari -->
                <div class="form-group">
                  <label for="kata-dicari">Kata yang di Cari :</label>
                  <input type="text" id="kata-dicari" placeholder="Masukkan kata yang anda cari..."
                    class="form-control rounded-lg" v-model="q" />
                </div>
                <!-- field kata di exclude -->
                <div class="form-group">
                  <label for="kata-exclude">Kata yang di Kecualikan :</label>
                  <input type="text" id="kata-exclude" placeholder="Masukkan kata yang anda kecualikan..."
                    class="form-control rounded-lg" v-model="excludes" />
                  <small class="text-muted">
                    <i class="bi bi-info-circle"></i> Jika kata lebih dari satu,
                    pisahkan dengan koma
                  </small>
                </div>
                <!-- field account / media -->
                <div class="form-group">
                  <label for="account-media">Akun/Media :</label>
                  <input type="text" id="account-media" placeholder="Masukkan nama akun atau nama media..."
                    class="form-control rounded-lg" v-model="account" />
                </div>
                <!-- field cakupan media -->
                <div class="form-group">
                  <label for="jenis-media">Cakupan Media :</label>
                  <div class="input-group input-group-left mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text bg-transparent" id="basic-addon1">
                        <i class="bi bi-flag"></i>
                      </span>
                    </div>
                    <select id="jenis-media" class="form-control" v-model="cakupan">
                      <option value="all">Tampilkan Semua</option>
                      <option value="nasional">
                        Media Nasional
                      </option>
                      <option value="internasional">
                        Media Internasional
                      </option>
                    </select>
                  </div>
                </div>
                <!-- field sorting -->
                <div class="form-group">
                  <label for="sorting">Urutkan :</label>
                  <div class="input-group input-group-left mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text bg-transparent">
                        <i class="bi bi-sort-down-alt"></i>
                      </span>
                    </div>
                    <select id="sorting" class="form-control" v-model="sort">
                      <option value="esmr">Terpopuler</option>
                      <option value="date">Terbaru</option>
                      <option value="dateOld">Terlama</option>
                      <option value="engagement">Keterlibatan</option>
                    </select>
                  </div>
                </div>
                <!-- field jenis media -->
                <div class="form-group">
                  <label for="jenis-media">Jenis Media :</label>
                  <div class="input-group input-group-left mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text bg-transparent" id="basic-addon1">
                        <i class="bi bi-eye"></i>
                      </span>
                    </div>
                    <select id="jenis-media" class="form-control" v-model="pers">
                      <option value="2">Tampilkan Semua</option>
                      <option value="1">Tampilkan Pers</option>
                      <option value="0">Tampilkan Non Pers</option>
                    </select>
                  </div>
                </div>
                <!-- field tier -->
                <div class="form-group">
                  <label for="tier">Tingkat :</label>
                  <div class="input-group input-group-left mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text bg-transparent" id="basic-addon1">
                        <i class="bi bi-stack"></i>
                      </span>
                    </div>
                    <select id="tier" class="form-control" v-model="tier">
                      <option value="0">Semua Tingkat</option>
                      <option value="1">Tingkat 1</option>
                      <option value="2">Tingkat 2</option>
                      <option value="3">Tingkat 3</option>
                      <option value="4">Tingkat 4</option>
                    </select>
                  </div>
                </div>
                <input type="submit" class="btn btn-warning float-right" value="Cari" />
                <input type="reset" class="btn btn-danger float-right mr-2" value="Batal" @click="cancelSearch" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "modal_advance_search",
  components: {},
  data() {
    return {
      queries: this.$route.query,
      q: this.$route.query.q ? this.$route.query.q : null,
      excludes: this.$route.query.excludes
        ? this.$route.query.excludes.replaceAll("|", ",")
        : null,
      account: this.$route.query.account ? this.$route.query.account : null,
      cakupan: this.$route.query.cakupan ? this.$route.query.cakupan : "all",
      sort: this.$route.query.sort ? this.$route.query.sort : "date",
      pers: this.$route.query.pers ? this.$route.query.pers : "2",
      tier: this.$route.query.tier ? this.$route.query.tier : "0",
    };
  },
  methods: {
    startSearch: function () {
      let params = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      if (this.q && this.q != " ") {
        params.q = this.q;
      }
      if (this.excludes && this.excludes != "") {
        let exc = this.excludes.replaceAll(",", "|");
        params.excludes = exc;
      }
      if (this.account) {
        let acc = this.account.replaceAll("@", "");
        params.account = acc;
      }
      if (this.cakupan != "all") {
        params.cakupan = this.cakupan;
      }
      if (this.sort) {
        params.sort = this.sort;
      }
      if (this.pers != "2") {
        params.pers = this.pers;
      }
      if (this.tier != 0) {
        params.tier = this.tier;
      }
      if (
        this.queries.q != params.q ||
        this.queries.excludes != params.excludes ||
        this.queries.account != params.account ||
        this.queries.cakupan != params.cakupan ||
        this.queries.sort != params.sort ||
        this.queries.pers != params.pers ||
        this.queries.tier != params.tier
      ) {
        this.$router.replace({
          query: params,
        });
      }

      this.$parent.show_modal_advance = false;
      $("#modal").modal("hide");
    },
    closeModal: function () {
      // var $trigger = $(".modal-lebar");
      // if ($trigger !== event.target && !$trigger.has(event.target).length) {
      this.$parent.show_modal_advance = false;
      // }
    },
    cancelSearch: function () {
      this.$parent.show_modal_advance = false;
      $("#modal").modal("hide");
    },
  },
  mounted: function () {
    $("#modal").modal("show");
  },
};
</script>

<style scoped>
.user-pic {
  width: 180px !important;
  height: 180px !important;
  position: relative;
}

.img-circle {
  height: 180px !important;
  width: 180px !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}

.propic-badge {
  position: relative;
  right: 15%;
  left: 20%;
  top: -9%;
  font-size: 12px;
  background: white;
  border-radius: 50%;
  border: 2px #eee solid;
  padding: 3px;
  width: 15%;
  height: 15%;
  max-width: 100%;
}

.background-image-post {
  background: -webkit-linear-gradient(#bc1888, #f09433);
  background-blend-mode: lighten;
  width: 500px;
  height: 600px;
  max-width: 800px;
}

.img-post {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.account-name {
  position: relative;
  bottom: 10px;
  left: 50px;
  font-size: 90%;
}

.subtitle {
  position: relative;
  left: 55px;
  bottom: 14px;
  font-size: 90%;
}

#content {
  min-height: 100px;
  max-height: 400px;
  overflow-y: scroll;
}

.modal.fade.fill-in>.close>i {
  font-size: 60px;
}

.modal-lebar {
  width: 70% !important;
}

.modal-number {
  font-size: 25px;
  color: black !important;
}

.content-post {
  max-height: 500px;
  max-width: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  direction: ltr;
  scrollbar-color: #d4aa70 #e4e4e4;
  scrollbar-width: thin;
}

.content-post::-webkit-scrollbar-thumb {
  background-image: linear-gradient(180deg, #d0368a 0%, #708ad4 99%);
  box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
  border-radius: 100px;
}

.content-post::-webkit-scrollbar {
  width: 10px;
}

.content-post::-webkit-scrollbar-track {
  background-color: #e4e4e4;
  border-radius: 100px;
}

.content-post::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background-image: linear-gradient(180deg, #bc1888, #f09433);
  box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
}
</style>
